<template>
  <v-content>
    <v-row no-gutters>
      <v-col cols="12">
       
        <v-flex class="pb-2 ml-0">
          <v-alert dense color="primary" class="text-left" text border="left"
            >CARDÁPIOS</v-alert
          >
        </v-flex>
      </v-col>
    </v-row>

    <v-card v-show="!sv">
      <v-row no-gutters>
        <v-col cols="4">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Pesquisar"
            filled
            dense
            single-line
            hide-details
          ></v-text-field>
        </v-col>
        <v-col class="text-left" cols="4">
          <v-btn
            v-show="$can('cardapios.create|admin.loja')"
            @click="novo()"
            color="topEnviados"
            dark
          >
            <v-icon>mdi-plus</v-icon>Novo
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="itemsCardapio"
        :loading="loading_table"
        :footerProps="footerProps"
        loading-text="Carregando... Aguarde"
        dense
        :search="search"
        no-data-text="Nenhum resultado encontrado!"
        no-results-text="Nenhum resultado encontrado!"
        class="elevation-1"
      >
      <template v-slot:item.vincular="{ item }">
      
        <v-icon
            color="green"
            class="mr-2"
            v-show="true"
            @click="vincularProduto(item)"
            >link</v-icon
          >
      </template>
      <template v-slot:item.chk_ativo="{ item }">
          <v-switch
            dense
            color="green"
            v-show="$can('cardapios.update|admin.loja')"
            :label="`${checkStatus(item.chk_ativo)}`"
            @change="mudarStatus(item.id, item.chk_ativo, 'chk_ativo')"
            v-model="item.chk_ativo"
            true-value="T"
            false-value="F"
          ></v-switch>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
            color="btBlue"
            class="mr-2"
            v-show="$can('cardapios.edit|admin.loja')"
            @click="editCardapio(item)"
            >edit</v-icon
          >
         <!-- <v-icon
            color="error"
            class="mr-2"
            v-show="$can('admin.loja|cardapios.delete')"
            @click="deleteCardapio(item)"
            >delete</v-icon
          >-->
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialogCadastro" persistent max-width="35%">
      <v-card>
     
        <v-card-title class>
          <span v-if="cadastro">Cadastrar Cardápio</span>
          <span v-if="cadastro == false">Editar Cardápio</span>
        </v-card-title>
        <v-card-text>
          <v-container>
          
              <v-col cols="12" md="8" lg="8">
                <v-text-field
                  v-model="cardapio.nome"
                  label="Nome"
                  filled
                  dense
                  clearable
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="8" lg="8">
                <v-text-field
                  v-model="cardapio.descricao"
                  label="Descrição"
                  filled
                  dense
                  clearable
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="12" lg="12" sm="12">
                <v-autocomplete   v-model="cardapio.dia_semana" id="id"   label="Dia semanda " :items="lista_dia_semana"  deletable-chips   multiple   small-chips item-value="id" item-text="dia"  filled ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" lg="4">
                <v-autocomplete  :auto-select-first="true" v-model="cardapio.hora_inicio"  ref="id" label="Hora inicio " :items="lista_hora_inicio"   filled ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="4" lg="4">
                <v-autocomplete  :auto-select-first="true" v-model="cardapio.hora_fim"  ref="id" label="Hora final " :items="lista_hora_fim"   filled ></v-autocomplete>
              </v-col>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-col cols="12" md="6" lg="6">
            <v-btn color="error" @click="dialogCadastro = false">
              <v-icon>mdi-close</v-icon>Fechar
            </v-btn>
          </v-col>

          <v-col cols="12" md="6" lg="6">
            <v-btn
              v-if="cadastro"
              color="success"
              class="mr-4"
              @click="gravar()"
            >
              <v-icon>mdi-check</v-icon>Gravar
            </v-btn>
            <v-btn
              v-if="cadastro == false"
              color="success"
              class="mr-4"
              @click="gravarEdicao()"
            >
              <v-icon>mdi-check</v-icon>Editar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogVinculaProduto" persistent max-width="35%">
      <v-card>
        <v-card-title class>
          <span >Vincula Produto Cardápio</span>
        
        </v-card-title>
        <v-card-text>
          <v-container>      
             
              <v-col cols="12" md="12" lg="12" sd="12" xs="12">
                <v-autocomplete dense
            chips
            :loading="carregandoVincullos"
            small-chips
            label="Produtos vinculados"
            multiple
            deletable-chips
              :auto-select-first="true" v-model="produtos" item-value="codigo" item-text="descricao_reduzida"  ref="codigo_produto"  :items="itemsProdutos" @change="gravarVinculo()"   filled ></v-autocomplete>
              </v-col>
          </v-container>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-col cols="12" md="6" lg="6">
            <v-btn color="error" @click="dialogVinculaProduto = false">
              <v-icon>mdi-close</v-icon>Fechar
            </v-btn>
          </v-col>

          <v-col cols="12" md="6" lg="6">
           
            <v-btn
              v-if="cadastro == false"
              color="success"
              class="mr-4"
              @click="gravarEdicao()"
            >
              <v-icon>mdi-check</v-icon>Editar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row justify="center">
      <v-dialog v-model="dialogCancel" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Excluir</v-card-title>
          <v-card-text>Deseja excluir essa Cardapio?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              class="white--text"
              @click="dialogCancel = false"
              >Não</v-btn>
          
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-snackbar
      :timeout="3000"
      :color="sucesso"
      :top="true"
      absolute
      :multi-line="'multi-line'"
      :vertical="'vertical'"
      v-model="snackbarSuccess"
    >
      {{ textSucesso }}
    
    </v-snackbar>

    <v-snackbar
      :timeout="3000"
      :color="error"
      :top="true"
      :multi-line="'multi-line'"
      :vertical="'vertical'"
      v-model="snackbarError"
    >
      {{ textSnack }}
     
    </v-snackbar>
  </v-content>
</template>

<script>
export default {
  props: {
    source: String,
  },
  data: () => ({
    cadastro: true,
    snackbarSuccess: false,
    snackbarError: false,
    snackbar: false,
    carregandoVincullos:false,
    textSucesso: "",
    textSnack: "",
    dialogVinculaProduto:false,
    sucesso: "botao_sucesso",
    error: "error",
    footerProps: { "items-per-page-options": [30, 50, 100] },
    singleLine: true,
    dia_semana:[],
    lista_dia_semana:[
      {id:'1', dia:'domingo'},{ id:'2', dia:'segunda'},{id:'3', dia:'terça'},{id:'4', dia:'quarta'},{id:'5', dia:'quinta'},{id:'6', dia:'sexta'},{id:'7', dia:'sábado'}],
      lista_hora_inicio:['01:00','02:00','03:00','04:00','05:00','06:00','07:00','08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00'],
      lista_hora_fim:['01:00','02:00','03:00','04:00','05:00','06:00','07:00','08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00'],
      
    cardapio: {
      nome:"",
      descricao: "",
      dia_semana: null,
      hora_inicio:"",
      hora_fim:""
    },
    cats: [],
    name: "",
    autoUpdate: true,

    isUpdating: false,
    imageFile: [],
    file: "",
    files: "",

    filtroProduto: "Produtos ",
    sv: false,
    dialogCadastro: false,
    itensPorPagina: 25,
    itemsCardapio: [],
    selectCardapio:null,
    itemsProdutos: [],
   
    search: "",
    searchVinculados: "",
    loading_table: false,
    selProduto: "",
    itemEdit: "",
    dialogCancel: false,
    selItem: "",
    catSel: "2",
    produtos: null,
    headers: [
      {
        text: "Nome",
        align: "left",
        value: "nome",
        width:"10%",
      },
      {
        text: "Descrição",
        value: "descricao",
        sortable: true,
        align: "left",
          width:"30%",
      },
      {
        text: "Dia da Semana",
        value: "dia_semana_texto",
        sortable: true,
        align: "left",
         width:"10%",
      },
      {
        text: "Hora inicio",
        value: "hora_inicio",
        sortable: true,
        align: "left",
         width:"7%",
      },
      {
        text: "Hora fim",
        value: "hora_fim",
        sortable: true,
        align: "left",
         width:"7%",
      },
      {
        text: "Vincular Produto",
        value: "vincular",
        sortable: true,
        align: "left",
         width:"10%",
      },
      {
        text: "Status",
        value: "chk_ativo",
        sortable: true,
        align: "left",
         width:"10%",
      },
      { text: "Ação", width:"10%",  align: "right", value: "action", sortable: false },
    ],
  }),
  watch: {
    isUpdating(val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000);
      }
    },
  },
  mounted() {
    
    this.cardapios();
    this.buscaProdutos();
  },
  methods: {
    mudarStatus(id, status, tipo) {
      axios
        .post(`/montagem/cardapio/mudar_status`, { id: id, status: status, tipo: tipo })
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            this.snackbarSuccess = true;
            this.textSucesso = "Status alterado!";
            //this.cardapios();
          }
        });
    },
    checkStatus(valor) {
      if (valor=="T") {
        return "ativo";
      } else {
        return "suspenso";
      }
    },
    retornaDiaSemana(dia) {
      
      const dia_da_semana=  [
      {
          
          dia_semana: "1",
          dia_semana_texto: "Domingo",
        
        },
        {          
          dia_semana: "2",
          dia_semana_texto: "Segunda-feira",
        
        },{
        
          dia_semana: "3",
          dia_semana_texto: "Terça-feira",
        
        },
        {
        
          dia_semana: "4",         
          dia_semana_texto: "Quarta-feira",
        
        },
        {
         
          dia_semana: "5",
          dia_semana_texto: "Quinta-feira",
        
        },
        {
         
         dia_semana: "6",
         dia_semana_texto: "Sexta-feira",
       
       },
       {
         
         dia_semana: "7",
         dia_semana_texto: "Sábado",
       
       },
      ];
      return dia_da_semana['dia_semana'][dia];
    },
    vincularProduto(item){
      //alert(item.id)
      this.produtos =null
      
      this.dialogVinculaProduto=true
      this.selectCardapio = item.id
      this.vinculados()

     
    },
    remove(item) {
      const index = this.catSel.indexOf(item.name);
      if (index >= 0) this.catSel.splice(index, 1);
    },
    novo() {
      this.dialogCadastro = true;

      this.limpaCampos();
      console.log(
        document.getElementsByClassName("v-file-input--text").innerHtml
      );
    },
    limpaCampos() {
      this.cadastro = true;
      this.cardapio.descricao = "";
      this.cardapio.nome = "";
      this.cardapio.hora_inicio="";
      this.cardapio.hora_fim="";
      this.cardapio.dia_semana=null;
      
      this.catSel = "";
    },
    fecharDialog() {},

    editCardapio(item) {
      this.dialogCadastro = true;
      this.cadastro = false;
      this.itemEdit = item.id;
      this.cardapio.id = item.id;
      this.cardapio.descricao = item.descricao;
      this.cardapio.nome = item.nome;
      this.cardapio.dia_semana = item.dia_semana;
      this.cardapio.dia_semana = item.dia_semana;
      this.cardapio.hora_inicio= item.hora_inicio;
      this.cardapio.hora_fim=item.hora_fim;
     
    },
    deleteCardapio(item) {
      this.selItem = item.id;
      this.dialogCancel = true;
    },

    deleta() {
      axios.delete(`montagem/cardapio/`+this.selItem ).then((response) => {
        if (response.data.error) {
          this.textSnack = response.data.error;
          this.snackbarError = true;
        } else {
          this.snackbarSuccess = true;
          this.textSucesso = response.data.msg;
          this.dialogCancel = false;
          this.cardapios();
        }
      });
    },
    vinculados() {
      this.carregandoVincullos = true;
      axios.get(`/montagem/cardapio/produto_vinculado/`+this.selectCardapio).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.produtos = response.data;
          this.carregandoVincullos =false
        }
      });
    },
    cardapios() {
      this.loading_table = true;
      axios.get(`/montagem/lista_cardapios`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.loading_table = false;
          this.itemsCardapio = response.data;
        }
      });
    },
    gravarVinculo(){
      var formData = new FormData();

      formData.append("produtos", this.produtos);
      formData.append("id_cardapio", this.selectCardapio);    

      axios
        .post(`/montagem/cardapio_produto`, formData)
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            //this.buscaProdutosSgt();
            this.snackbarSuccess = true;
            this.textSucesso = response.data.msg;
           // this.limpaCampos();
           // this.dialogCadastro = false;
           // this.cardapios();
          }
        })
        .catch((e) => {
          if (!Array.isArray(e.response.data)) {
            let itens = [];
            for (var prop in e.response.data) {
              itens.push(e.response.data[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.error;
            this.snackbar = true;
          }
        });

    },
    gravar() {
      let config = { headers: { "Content-Type": "multipart/form-data" } };
      var formData = new FormData();

    
      formData.append("dia_semana", this.cardapio.dia_semana);
      formData.append("hora_inicio", this.cardapio.hora_inicio);
      formData.append("hora_fim", this.cardapio.hora_fim);
      //formData.append("codigo_img", this.catSel);
      formData.append("nome", this.cardapio.nome);
      formData.append("descricao", this.cardapio.descricao);

      axios
        .post(`montagem/cardapio`, formData, config)
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            //this.buscaProdutosSgt();
            this.snackbarSuccess = true;
            this.textSucesso = response.data.msg;
            //this.cardapio.descricao = "";
            //this.cardapio.ordem = "";

            this.novo();
            this.cardapios();
          }
        })
        .catch((e) => {
          if (e.response.data != undefined) {
            if (!Array.isArray(e.response.data)) {
              let itens = [];
              for (var prop in e.response.data) {
                itens.push(e.response.data[prop][0]);
              }
              this.textSnack = itens.join(" ");
              this.snackbarError = true;
            } else {
              this.textSnack = e.response.error;
              this.snackbarError = true;
            }
          }
        });
    },
    gravarEdicao() {
      let config = { headers: { "Content-Type": 'multipart/form-data' } };
      var formData = new FormData();
      formData.append("id", this.cardapio.id);
      formData.append("dia_semana", this.cardapio.dia_semana);
      formData.append("hora_inicio", this.cardapio.hora_inicio);
      formData.append("hora_fim", this.cardapio.hora_fim);
      //formData.append("codigo_img", this.catSel);
      formData.append("nome", this.cardapio.nome);
      formData.append("descricao", this.cardapio.descricao);

      axios
        .post(`/montagem/cardapio/editar`, formData, config)
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            //this.buscaProdutosSgt();
            this.snackbarSuccess = true;
            this.textSucesso = response.data.msg;
            this.limpaCampos();
            this.dialogCadastro = false;
            this.cardapios();
          }
        })
        .catch((e) => {
          if (!Array.isArray(e.response.data)) {
            let itens = [];
            for (var prop in e.response.data) {
              itens.push(e.response.data[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.error;
            this.snackbar = true;
          }
        });
    },

    buscaProdutos() {
      axios.get(`/adm/produto/lista`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          // this.loading_table = false;
          //this.loading_filtrar = false;
          this.itemsProdutos = response.data;
        }
      });
    },
  },
};
</script>
<style scoped>
.v-input--selection-controls {
  padding: 5px !important;
  margin-bottom: 5px !important;
  margin-top: 16px;
  padding-top: 4px;
}
.v-data-table td {
  font-size: 0.685rem !important;
}
</style>
